import { render, staticRenderFns } from "./Transportista.vue?vue&type=template&id=c0714fac"
import script from "./Transportista.vue?vue&type=script&lang=js"
export * from "./Transportista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports